import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DesktopDirective } from './responsive/desktop.directive';
import { MobileDirective } from './responsive/mobile.directive';

@NgModule({
  declarations: [
    DesktopDirective,
    MobileDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    DesktopDirective,
    MobileDirective
  ]
})
export class SharedModule { }
